export default function () {
  let onClickAttr = 'data-gtm-click';
  let clicks = document.querySelectorAll(`[${onClickAttr}]`);

  [].forEach.call(clicks, (element) => {
    element.addEventListener('click', () => {
      let data = JSON.parse(element.getAttribute(onClickAttr));

      push(data);
    });
  });

  let push = (data) => {
    window.dataLayer.push({
      'event': 'setapp',
      'eventCategory': data.eventCategory || '',
      'eventAction': data.eventAction || '',
      'eventLabel': data.eventLabel || '',
      'eventValue': data.eventValue || '',
      'eventNonInteraction': data.eventNonInteraction === 1,
    });
  };
}